/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, defineMessages } from 'react-intl';
import cn from 'classnames';
import Login from '../../components/Login';
import s from './Home.css';
import history from '../../history';
import Button from '../../components/Button';
import Box from '../../components/Box/Box';
import Heading from '../../components/Heading/Heading';
import Headline from '../../components/Headline/Headline';
import Image from '../../components/Image/Image';

const messages = defineMessages({
  signup: {
    id: 'label.signup',
    defaultMessage: 'Sign Up',
    description: 'Label signup',
  },
  or: {
    id: 'label.or',
    defaultMessage: 'OR',
    description: 'Label or',
  },
});

class Home extends React.Component {
  render() {
    return (
      <div>
        <Box tag="section" align flex column padding="medium">
          <div className={s.framer}>
            <Box column align>
              <Box align column>
                <Headline>Create blazing fast infopages –</Headline>
                <Headline>
                  <span className={s.framerText}>
                    your readers will love it.
                  </span>
                </Headline>
              </Box>
              <div>
                <Heading tag="h3">
                  <p>
                    Make your own templates, easily translate your posts and
                    give your community an 5-star experience
                  </p>
                </Heading>
              </div>
              <div>
                <Box padding="small">
                  <Button primary>Try the sandbox!</Button>
                  <Button onClick={() => history.push('/login')}>Login</Button>
                </Box>
              </div>
            </Box>
          </div>
        </Box>
        <Box className={cn(s.framer, s.wrapper)}>
          <div className={s.frame} />
          <div className={s.frame2} />
          <div className={s.frame3} />
          <div className={s.frame4} />

          <div className={(s.framer, s.imgFrame)}>
            <div className={s.imgFrame2}>
              <div className={s.imgFrame3}>
                <Image className={s.imgHero} src="/Design.png" />
              </div>
            </div>
          </div>
        </Box>
      </div>
    );
  }
}

export default withStyles(s)(Home);
